import { PackagePlus, Truck } from 'lucide-react';
import { Link } from 'react-router';

const menuItems = [
  { to: '/picking', label: 'ピッキング＆出荷', icon: Truck },
  { to: '/receiving', label: '入荷', icon: PackagePlus },
];

export const TopPage = () => {
  return (
    <div className="flex flex-col gap-5 px-5 py-3">
      {menuItems.map((item) => (
        <Link
          key={item.to}
          to={item.to}
          className="bg-white flex flex-col items-center justify-center py-4 rounded-lg shadow-md"
        >
          <item.icon className="size-38 stroke-1" />
          <p className="text-xl font-bold">{item.label}</p>
        </Link>
      ))}
    </div>
  );
};
